import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CreateContractDialogComponentInputData } from 'src/app/lib/contract/components/dialog/create-contract-dialog/create-contract-dialog.component';
import { DOUBLET_PROVIDER_SERVICE, OFFER_PROVIDER_SERVICE } from 'src/app/lib/shared/interfaces';
import { Offer } from '../../../classes';
import { CreateOfferService } from '../../../services/create-offer-service';
import { OfferService } from '../../../services/offer.service';

@Component({
  selector: 'app-create-offer',
  templateUrl: './create-offer.component.html',
  styleUrls: ['./create-offer.component.css'],
  providers: [
    { provide: DOUBLET_PROVIDER_SERVICE, useClass: CreateOfferService },
    { provide: OFFER_PROVIDER_SERVICE, useExisting: DOUBLET_PROVIDER_SERVICE }
  ]
})
export class CreateOfferComponent implements OnInit {

  formGroup: FormGroup;

  constructor(
    @Inject(DOUBLET_PROVIDER_SERVICE) public service: CreateOfferService,
    private _dialogRef: MatDialogRef<CreateOfferComponent>,
    private _formBuilder: FormBuilder,
    private _offerService: OfferService,
    private _router: Router,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) private _data: CreateContractDialogComponentInputData
  ) {
    this.formGroup = this._formBuilder.group({
      offer: this._formBuilder.group(new Offer())
    });
  }

  close = () => this._dialogRef.close();

  ngOnInit(): void {
    if(this._data.patchValue) (this.formGroup.controls['offer'] as FormGroup).patchValue(this._data.patchValue);
    this.setValidators();
  }

  saveOffer(){
    this._offerService.createOffer((this.formGroup.controls['offer'] as FormGroup).getRawValue(), null).subscribe({
      next: (offer: Offer) => {
        if(!this._data.preventNavigation) this._router.navigate(['/offer-details', offer.offerid]);
        this._dialogRef.close(offer);
      },
      error: (error: HttpErrorResponse) => this._snackBar.open(`Fehler beim Erzeugen des Angebots (${error.status}): ${error.message}`)
    });
  }

  setValidators(){
    (this.formGroup.controls['offer'] as FormGroup).controls['offertitle'].setValidators(Validators.compose([
      Validators.required,
      Validators.minLength(6)
    ]));
  }

}

export class CreateOfferComponentInputData {
  preventNavigation: boolean;
  patchValue: Offer;
}
